module.exports = __webpack_public_path__ + "static/media/search-white.38de753d.svg";